exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-body[data-v-4bdfe944] {\n  max-height: calc(100vh - 200px);\n  overflow-y: auto;\n}\n", ""]);

// exports
